import React from 'react'
import BannerCreate from '../banner_components/banner_create'

export default function Main() {
  return (
    <div className='content-wrapper bg-white p-5' style={{ marginLeft: 0 }}>
      <div>
        <h2>Create Banner</h2>
        <BannerCreate />
      </div>
    </div>
  )
}
